import { ActionType } from 'typesafe-actions';
import * as formAction from './form';
import * as onBoardingAction from './onboarding';

export const formActions = { ...formAction };
export const onBoardingActions = { ...onBoardingAction };

export type FormActions = ActionType<typeof formAction>;
export type OnBoardingActions = ActionType<typeof onBoardingAction>;
